import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../colors';
import breakpoints from '../../breakpoints';
import CheggLogo from './CheggLogo';
import { getHeaderLogoWidthByProductName, BASE_HEADER_LOGO_WIDTH, TRADEMARK_TEXT_WIDTH, BASE_BOX_WIDTH } from '../shared';

var getHeaderLogoWidth = function getHeaderLogoWidth(productName, showTrademarkText) {
  return getHeaderLogoWidthByProductName(productName) + (productName && showTrademarkText ? BASE_HEADER_LOGO_WIDTH * TRADEMARK_TEXT_WIDTH / BASE_BOX_WIDTH : 0);
};

var ResizedHeaderLogo = styled(CheggLogo).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['resize'].includes(prop);
  }
}).withConfig({
  displayName: "CheggHeaderLogo__ResizedHeaderLogo",
  componentId: "jngbm3-0"
})(["height:30px;width:", "px;", ""], function (_ref) {
  var productName = _ref.productName,
      showTrademarkText = _ref.showTrademarkText;
  return getHeaderLogoWidth(productName, showTrademarkText);
}, function (_ref2) {
  var resize = _ref2.resize,
      productName = _ref2.productName;
  return resize ? css(["@media screen and (max-width:", "){height:20px;width:", "px;}"], breakpoints.md.max, Math.round(getHeaderLogoWidthByProductName(productName) * 0.66667)) : '';
});
/**
 * Renders Chegg product logos in Chegg orange and dimensions appropriate for the sitewide header.
 */

var CheggHeaderLogo = function CheggHeaderLogo(_ref3) {
  var _ref3$role = _ref3.role,
      role = _ref3$role === void 0 ? 'img' : _ref3$role,
      _ref3$svgColor = _ref3.svgColor,
      svgColor = _ref3$svgColor === void 0 ? colors.cheggOrange : _ref3$svgColor,
      _ref3$resize = _ref3.resize,
      resize = _ref3$resize === void 0 ? true : _ref3$resize,
      rest = _objectWithoutProperties(_ref3, ["role", "svgColor", "resize"]);

  return /*#__PURE__*/React.createElement(ResizedHeaderLogo, _extends({
    role: role,
    svgColor: svgColor,
    resize: resize
  }, rest));
};

CheggHeaderLogo.displayName = 'CheggHeaderLogo';
export default CheggHeaderLogo;